import { fabric } from 'fabric';
import { cloneFabricObject } from '../helpers/clone-handler';

export class ClippingMaskEffect {
  isActive(obj) {
    if (!obj?.canvas || !obj?.element_id || obj.isClippingMask) {
      return false;
    }

    return this._findClippingMasks(obj).length > 0 || (Array.isArray(obj.masks) && obj.masks.length > 0);
  }

  apply(obj, effectsRenderBuffer) {
    const clippingMasks = this._findClippingMasks(obj);
    const masksArray = Array.isArray(obj.masks) ? obj.masks : [];

    if (clippingMasks.length === 0 && masksArray.length === 0) {
      return null;
    }

    let offsetX = effectsRenderBuffer.offsetX;
    let offsetY = effectsRenderBuffer.offsetY;
    const canvasWidth = effectsRenderBuffer.canvas ? effectsRenderBuffer.canvas.width : obj.getScaledWidth();
    const canvasHeight = effectsRenderBuffer.canvas ? effectsRenderBuffer.canvas.height : obj.getScaledHeight();

    const clone = effectsRenderBuffer.canvas
      ? new fabric.Image(effectsRenderBuffer.canvas)
      : cloneFabricObject(obj, {
        left: 0,
        top: 0,
        skew: null,
        smartObject: null,
        clipPath: null,
        shadow: null,
        selectable: false
      });

    if (clone.originX === 'center' && clone.originY === 'center') {
      clone.setPositionByOrigin({
        x: canvasWidth / 2,
        y: canvasHeight / 2
      }, 'center', 'center');
      clone.setCoords();

      offsetX += canvasWidth / 2;
      offsetY += canvasHeight / 2;
    }

    if (obj.clipPath && !effectsRenderBuffer.canvas) {
      const cp = fabric.util.object.clone(obj.clipPath);
      cp.absolutePositioned = true;

      const objRect = obj.getBoundingRect(true);
      const cloneRect = clone.getBoundingRect(true);

      const clipOffsetX = cloneRect.left - objRect.left;
      const clipOffsetY = cloneRect.top - objRect.top;

      cp.left = (cp.left || 0) + clipOffsetX;
      cp.top = (cp.top || 0) + clipOffsetY;

      clone.clipPath = cp;
    }

    const tempCanvas = new fabric.StaticCanvas(null, {
      width: canvasWidth,
      height: canvasHeight,
      enableRetinaScaling: false,
    });

    tempCanvas.add(clone);

    for (const clippingMask of clippingMasks) {
      let groupX = 0;
      let groupY = 0;

      if (clippingMask.group) {
        const groupOffset = clippingMask.group.getPointByOrigin(clippingMask.originX, clippingMask.originY);
        groupX = groupOffset.x;
        groupY = groupOffset.y;
      }

      const clippingMaskClone = cloneFabricObject(clippingMask, {
        left: clippingMask.left - obj.left + offsetX + groupX,
        top: clippingMask.top - obj.top + offsetY + groupY,
        isClippingMask: false,
        globalCompositeOperation: 'source-atop'
      });

      tempCanvas.add(clippingMaskClone);
    }


    const cloneLeftTopPoint = clone.getPointByOrigin('left', 'top');
    for (const maskObj of masksArray) {
      const maskClone = cloneFabricObject(maskObj, {
        left: (maskObj.left || 0) + cloneLeftTopPoint.x,
        top: (maskObj.top || 0) + cloneLeftTopPoint.y,
        scaleX: maskObj.scaleX,
        scaleY: maskObj.scaleY,
        selectable: false,
        evented: false,
        globalCompositeOperation: 'destination-in'
      });

      tempCanvas.add(maskClone);
    }

    tempCanvas.renderAll();

    return {
      canvas: tempCanvas.toCanvasElement(),
      offsetX,
      offsetY
    };
  }

  _findClippingMasks(obj) {
    const objects = obj.canvas.getObjects().filter(obj => obj.element_id);
    const index = objects.indexOf(obj);
    const masks = [];

    for (let i = index + 1; i < objects.length; i++) {
      const next = objects[i];

      if (next.isClippingMask) {
        masks.push(next);
      } else {
        break;
      }
    }

    return masks;
  }
}
